<template>

	<article class="home">
		<div class="content">

			<div class="jumbo jumbo-a">
				<div class="jumbo-content">
					<h2 class="text-uppercase">Website Development</h2>
					<router-link to="website-development" class="btn btn-default btn-lg text-uppercase">Read more</router-link>
					<p>We provide customized web-based solutions tailored to the client’s specific business requirements using the latest technologies and industry trends.</p>
				</div>
			</div>

			<div class="jumbo jumbo-b">
				<div class="jumbo-content">
					<h2 class="text-uppercase">Front-End Outsourcing</h2>
					<router-link to="front-end-outsourcing" class="btn btn-default btn-lg text-uppercase">Read more</router-link>
					<p>While you focus on your core business process, our expert web developers will maximize your ability to deliver high quality product and speed up time-to-market.</p>
				</div>
			</div>

		</div>
	</article>

</template>

<script>
	export default {
		name: 'home',
		data () {
			return {
			}
		}
	}
</script>

<style scoped>
	.home .content { padding:0 15px 0 30px; }

	.jumbo { position:relative; width:100%; min-width:350px; max-width:774px; height:352px; overflow:hidden; }
	.jumbo .jumbo-content { position:absolute; width:350px; padding:0 20px; top:50%; transform: translateY(-50%); text-align:center; }
	.jumbo .jumbo-content h2 { margin:0 0 20px; }
	.jumbo .jumbo-content .btn { margin:0 0 20px; }
	.jumbo .jumbo-content p { font-size:16px; }

	.jumbo.jumbo-a { background:#e8ae0c url('/static/images/home.jpg') 0 0 no-repeat; margin-bottom:5px; }
	.jumbo.jumbo-a .jumbo-content { left:0; color:#000; }
	.jumbo.jumbo-a .jumbo-content h2 { color:#000; }
	.jumbo.jumbo-a .jumbo-content .btn { color:#000; background-color:#e8ae0c; border-color:#000;  }
	.jumbo.jumbo-a .jumbo-content .btn:hover { background-color: #ECC453; }

	/*.jumbo.jumbo-b { width:100%; height:352px; background: #9DC49D; }*/
	/*.jumbo.jumbo-b { width:100%; height:352px; background: #B85C8A; }*/
	.jumbo.jumbo-b { background:#6B2046 url('/static/images/home1.jpg') 0 0 no-repeat; }
	.jumbo.jumbo-b .jumbo-content { right:0; color:#fff; }
	.jumbo.jumbo-b .jumbo-content h2 { color:#fff; }
	.jumbo.jumbo-b .jumbo-content .btn { color:#fff; background-color:#6B2046; border-color:#fff; }
	.jumbo.jumbo-b .jumbo-content .btn:hover { background-color: #511835; }

	@media (max-width: 992px){
		.home .content { padding: 10px 0; }
		.jumbo.jumbo-b { background-position-x:-175px; }
	}

	@media (max-width: 570px){
		.jumbo,
		.jumbo.jumbo-a,
		.jumbo.jumbo-b { background-image: none; }
		.jumbo .jumbo-content { width:100%; }
	}

</style>



// WEBPACK FOOTER //
// home.vue?f838a526